/* aurora-load-more — "Load more" button + infinite scroll for the collection
   grid. Fetches the next page, appends its grid items, updates the next URL. */
if (!customElements.get('aurora-load-more')) {
  customElements.define('aurora-load-more', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-alm-btn]');
      if (!this.btn) return;
      this.btn.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
      if (this.dataset.mode === 'infinite') {
        new IntersectionObserver((es) => { if (es[0].isIntersecting) this.load(); }, { rootMargin: '600px' }).observe(this);
      }
    }
    load() {
      if (this.loading || !this.btn) return;
      this.loading = true;
      this.btn.classList.add('is-loading');
      fetch(this.btn.href)
        .then((r) => r.text())
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.getElementById('product-grid');
          var next = doc.getElementById('product-grid');
          if (grid && next) next.querySelectorAll(':scope > .grid__item').forEach((li) => grid.appendChild(li));
          var nb = doc.querySelector('[data-alm-btn]');
          if (nb) { this.btn.href = nb.href; this.btn.classList.remove('is-loading'); }
          else this.remove();
          this.loading = false;
        })
        .catch(() => { this.loading = false; this.btn.classList.remove('is-loading'); });
    }
  });
}
